import {GetContentType, ContentType, CreateContent, Content} from "./ContentBase";

export type ComponentType = {
  render:()=>any;
  load?:()=>void;
  unload?:()=>void;
  $get?:(key:string)=>any;
  $set?:(key:string,v:any)=>void;
  $parent?:ComponentType;
  $redraw?:()=>Promise<void>;
  /** @deprecated Use .$redraw instead */
  $app?:{redraw:()=>Promise<void>};  // only for backwards compat
}

export type ComponentWrapper=[new()=>ComponentType] |
  [new()=>ComponentType,Object] |
  [new()=>ComponentType,Object,(c:ComponentType)=>void];


export function HookUpContext(comp:ComponentType,parentComp:ComponentType=null) {
  let CtxValues:Map<string,any>;
  comp.$get=(key:string):any=>{
    if(CtxValues && CtxValues.has(key)) return CtxValues.get(key);
    if(parentComp) return parentComp.$get(key);
    return undefined;
  };
  comp.$set=(key:string,v:any)=>{
    if(!CtxValues) CtxValues=new Map<string,any>();
    CtxValues.set(key,v);
  }
}

export function CreateContentComponent(cw:ComponentWrapper,setContent:(newContent:Node)=>void, curComp:ComponentType):Content {
  let comp = new cw[0];
  comp.$parent=curComp;
  comp.$redraw=()=>curComp.$redraw();
  comp.$app={redraw:()=>curComp.$redraw()}; // only for backwards compat
  HookUpContext(comp,curComp);

  if(cw.length>1) Object.assign(comp,cw[1]);
  if(cw.length>2) cw[2](comp);
  if(comp.load) comp.load();
  if(!comp.render || typeof comp.render!=="function") throw new Error("Katla: Component must have .render method");
  let Output=comp.render();
  let ctType=GetContentType(Output);
  let Content=CreateContent(Output,setContent,comp);
  
  let WasUnloaded=false;
  return {
    Update:(v:ComponentWrapper)=>{
      if(WasUnloaded) return;
      cw=v;
      if(cw.length>1) Object.assign(comp,cw[1]);
      Output=comp.render();
      let ctType2=GetContentType(Output);
      if(ctType2===ContentType.NoChange) return;
      if(ctType===ctType2 && Content.MatchForUpdate(Output)) {
        Content.Update(Output)
      } else {
        Content.Unload();
        ctType=ctType2;
        Content=CreateContent(Output,setContent,comp);
      }
    },
    Unload:()=>{
      if(WasUnloaded) return;
      if(comp.unload) comp.unload();
      Content.Unload();
      WasUnloaded=true;
    },
    MatchForUpdate:(v:ComponentWrapper)=> cw[0] === v[0]
  }
}
